export default {
    'zh_CN': {
        'ipms.attendance-records.id.label': '主键ID',
        'ipms.attendance-records.id.holder': '请输入主键ID',
        
        
        'ipms.attendance-records.id.required': '主键ID必填',
        'ipms.attendance-records.attendanceUserId.label': '考勤员工表ID',
        'ipms.attendance-records.attendanceUserId.holder': '请输入考勤员工表ID',
        
        
        'ipms.attendance-records.attendanceUserId.required': '考勤员工表ID必填',
        'ipms.attendance-records.attendanceDate.label': '考勤日期',
        'ipms.attendance-records.attendanceDate.holder': '请输入考勤日期',
        'ipms.attendance-records.attendanceDate.required': '考勤日期必填',
        'ipms.attendance-records.attendanceType.label': '考勤类型',
        'ipms.attendance-records.attendanceType.holder': '请输入考勤类型',
        'ipms.attendance-records.attendanceType.max': '考勤类型最多50个字符',
        
        'ipms.attendance-records.attendanceType.dictionary': ()=>[{value:'0',label:'出勤'},{value:'1',label:'病假'},{value:'2',label:'事假'},{value:'3',label:'探亲'},{value:'4',label:'婚丧'},{value:'5',label:'工伤'},{value:'6',label:'年休'},{value:'7',label:'旷工'},{value:'8',label:'产假'},{value:'9',label:'夜班'},{value:'10',label:'加班'}],
        'ipms.attendance-records.attendanceType.required': '考勤类型必填',
        'ipms.attendance-records.createTime.label': '创建时间',
        'ipms.attendance-records.createTime.holder': '请输入创建时间',
        'ipms.attendance-records.createTime.required': '创建时间必填',
        'ipms.attendance-records.updateTime.label': '更新时间',
        'ipms.attendance-records.updateTime.holder': '请输入更新时间',
        'ipms.attendance-records.updateTime.required': '更新时间必填',
        'ipms.attendance-records.deleted.label': '是否删除',
        'ipms.attendance-records.deleted.holder': '请输入是否删除',
        'ipms.attendance-records.deleted.required': '是否删除必填'
    },
    'zh_TW': {
        'ipms.attendance-records.id.label': '主键ID',
        'ipms.attendance-records.id.holder': '請輸入主键ID',
        
        
        'ipms.attendance-records.id.required': '主键ID必填',
        'ipms.attendance-records.attendanceUserId.label': '考勤员工表ID',
        'ipms.attendance-records.attendanceUserId.holder': '請輸入考勤员工表ID',
        
        
        'ipms.attendance-records.attendanceUserId.required': '考勤员工表ID必填',
        'ipms.attendance-records.attendanceDate.label': '考勤日期',
        'ipms.attendance-records.attendanceDate.holder': '請輸入考勤日期',
        
        
        'ipms.attendance-records.attendanceDate.required': '考勤日期必填',
        'ipms.attendance-records.attendanceType.label': '考勤类型',
        'ipms.attendance-records.attendanceType.holder': '請輸入考勤类型',
        
        
        'ipms.attendance-records.attendanceType.required': '考勤类型必填',
        'ipms.attendance-records.createTime.label': '创建时间',
        'ipms.attendance-records.createTime.holder': '請輸入创建时间',
        
        
        'ipms.attendance-records.createTime.required': '创建时间必填',
        'ipms.attendance-records.updateTime.label': '更新时间',
        'ipms.attendance-records.updateTime.holder': '請輸入更新时间',
        
        
        'ipms.attendance-records.updateTime.required': '更新时间必填',
        'ipms.attendance-records.deleted.label': '是否删除',
        'ipms.attendance-records.deleted.holder': '請輸入是否删除',
        
        
        'ipms.attendance-records.deleted.required': '是否删除必填'
    },
    'en_US': {
        'ipms.attendance-records.id.label': 'id',
        'ipms.attendance-records.id.holder': 'Enter id',
        'ipms.attendance-records.id.max': 'id max length: 主键ID',
        
        
        'ipms.attendance-records.id.required': 'id required',
        'ipms.attendance-records.attendanceUserId.label': 'attendanceUserId',
        'ipms.attendance-records.attendanceUserId.holder': 'Enter attendanceUserId',
        'ipms.attendance-records.attendanceUserId.max': 'attendanceUserId max length: 考勤员工表ID',
        
        
        'ipms.attendance-records.attendanceUserId.required': 'attendanceUserId required',
        'ipms.attendance-records.attendanceDate.label': 'attendanceDate',
        'ipms.attendance-records.attendanceDate.holder': 'Enter attendanceDate',
        'ipms.attendance-records.attendanceDate.max': 'attendanceDate max length: 考勤日期',
        
        
        'ipms.attendance-records.attendanceDate.required': 'attendanceDate required',
        'ipms.attendance-records.attendanceType.label': 'attendanceType',
        'ipms.attendance-records.attendanceType.holder': 'Enter attendanceType',
        'ipms.attendance-records.attendanceType.max': 'attendanceType max length: 考勤类型',
        
        
        'ipms.attendance-records.attendanceType.required': 'attendanceType required',
        'ipms.attendance-records.createTime.label': 'createTime',
        'ipms.attendance-records.createTime.holder': 'Enter createTime',
        'ipms.attendance-records.createTime.max': 'createTime max length: 创建时间',
        
        
        'ipms.attendance-records.createTime.required': 'createTime required',
        'ipms.attendance-records.updateTime.label': 'updateTime',
        'ipms.attendance-records.updateTime.holder': 'Enter updateTime',
        'ipms.attendance-records.updateTime.max': 'updateTime max length: 更新时间',
        
        
        'ipms.attendance-records.updateTime.required': 'updateTime required',
        'ipms.attendance-records.deleted.label': 'deleted',
        'ipms.attendance-records.deleted.holder': 'Enter deleted',
        'ipms.attendance-records.deleted.max': 'deleted max length: 是否删除',
        
        
        'ipms.attendance-records.deleted.required': 'deleted required'
    }
}
